import { Grid, Avatar } from '@material-ui/core';
import styles from '../Styles/globalStyles.module.css';
import { Skeleton } from '@material-ui/lab';
import { ProgressBar, CustomButton } from 'shared_ui_components';
import iconSubmit from 'assets/roleplay/iconSubmit.svg';
import SubmitPublicRoleplayLogic from './SubmitPublicRoleplay.logic';

const SubmitPublicRoleplay = () => {
  const {
    isLoading,
    isNotEmpty,
    assigned_by_user,
    scenarios,
    scenariosCompleted,
    title,
    roleplay_description,
    initialLetter,
    userName,
    formattedEndDate,
    handleSubmit,
    enabled,
    isLoadingSubmit,
  } = SubmitPublicRoleplayLogic();

  if (isLoading || !scenarios?.length > 0)
    return (
      <Grid
        container
        direction="row"
        spacing={2}
        style={{ padding: '1rem 0 0 1rem', width: '100%' }}
      >
        <Grid item xs={12} md={8} lg={6} style={{ margin: '0 auto' }}>
          <Skeleton variant="rect" width="100%" height="50vh" style={{ borderRadius: '0.5rem' }} />
        </Grid>
      </Grid>
    );

  return (
    <div
      style={{
        width: '100%',
        boxSizing: 'border-box',
        height: '100dvh',
        background: '#f3f5f8',
      }}
    >
      <Grid
        container
        direction="row"
        spacing={2}
        style={{ padding: '1rem 0 0 1rem', width: '100%' }}
      >
        <Grid item xs={12} md={8} lg={6} style={{ margin: '0 auto' }}>
          <div className={styles.background}>
            <div className={styles.roleplayHeader}>
              <div>
                <div className={styles.tittle}>
                  <p className="heading4">{title || ''}</p>
                </div>
                <div>
                  <span className={'heading6'}>
                    {`${scenariosCompleted || 0}/${scenarios?.length || 0}`}{' '}
                  </span>
                  <span className="supportText" style={{ marginTop: 2 }}>
                    Scenarios completed
                  </span>
                  <ProgressBar
                    inProgress
                    value={(scenariosCompleted * 100) / scenarios?.length}
                    max={100}
                    hideLabel={true}
                  />
                </div>
              </div>

              {isNotEmpty && (
                <div className={`${styles.description_header} ${styles.description_header_submit}`}>
                  <div>
                    <div className={styles.description_header_title}>Assigned</div>
                    <div className={styles.avatar}>
                      <Avatar className={styles.img} alt="" src={assigned_by_user?.profile_pic}>
                        {initialLetter}
                      </Avatar>
                      <h4>{userName}</h4>
                    </div>
                  </div>
                  <div>
                    <div className={styles.description_header_title}>Due Date</div>
                    <h4 style={{ marginTop: '1rem' }}>{formattedEndDate}</h4>
                  </div>
                </div>
              )}
            </div>
            <div>
              {scenarios.map((scenario, index) => {
                const completed = scenario.response.video ? true : false;
                const scenario_title = scenario.is_default === false ? scenario.name : title;
                const description = scenario.description
                  ? scenario.description
                  : roleplay_description;
                return (
                  <div className={styles.cardContainer} key={index}>
                    <div className={styles.cardTitle}>
                      <div
                        className={`${styles.cardIndex} ${
                          !completed ? styles.cardIndexUncompleted : ''
                        }`}
                      >
                        <strong>{index + 1}</strong>
                      </div>
                      <img src={iconSubmit} alt="icon" className={`${styles.cardIcon}`} />
                      <div className="heading6">{scenario_title}</div>
                    </div>
                    <div className="supportText">{description}</div>
                  </div>
                );
              })}
              <div className={styles.submitButton}>
                <CustomButton onClick={handleSubmit} disabled={!enabled || isLoadingSubmit}>
                  Submit
                </CustomButton>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default SubmitPublicRoleplay;
